module.exports = __webpack_public_path__ + "img/dark-green-circle-table-1.267295af.png";